const getModifiers = (base, modifier) => {
  if (Array.isArray(modifier)) {
    const modifiers = modifier.map(modi => validateModifier(base, modi, false));
    modifiers.unshift(base);
    const uniqueModifiers = [...new Set(modifiers)];

    return uniqueModifiers.join(' ');
  }
  return validateModifier(base, modifier);
};

const validateModifier = (base, modifier, withBase = true) => {
  const isValidModifier = modifier && typeof modifier === 'string';
  if (isValidModifier) return withBase ? `${base} ${base}--${modifier}` : `${base}--${modifier}`;

  return base;
};

export default getModifiers;
